module.exports = __webpack_public_path__ + "img/brunellogo_black.70c896ed.svg";